import SglContext from '../SglContext';
import exclamation_image from '../images/Exclamation.gif'
import { Link } from 'react-router-dom';


const axios = require("axios").default;
const { useState, useEffect, useContext } = require("react");

function MySchedule(props) {


  const [show_details, setShowDetails] = useState({});
  const [entries, setEntries] = useState([]);
  const [shows_list, setShowsList] = useState([]);
  const [current_show, setCurrentShow] = useState(localStorage.getItem('show_id'));
  const [show_days_list, setShowDaysList] = useState([]);
  const [show_date, setShowDate] = useState('00/00/00');
  const [display, setDisplay] = useState('all');
  const [loading, setLoading] = useState(true);
  const [userData, setUserData] = useState({});
  const Sgl = useContext(SglContext);


  useEffect(() => {
    getAllData(show_date, props.currentShow)
  }, [show_date, props.currentShow, Sgl.currentTeamId]);

  const getScheduleData = (show_date, show) => {
    axios.get(Sgl.nestApiUrl + '/schedule/my', {
      params: {
        date: show_date,
        show_id: show,
        customer_id: Sgl.company_id,
        team_id: Sgl.currentTeamId != 'personal'?Sgl.currentTeamId:0,
      }
    }).then(res => {
      Sgl.reportToGA('/sgl-wp-plugin/' + Sgl.company_urlpath + '/' + res.data.show.show_id + '/schedule/my/' + res.data.show_date);
      Sgl.reportToFB('/sgl-wp-plugin/' + Sgl.company_urlpath + '/' + res.data.show.show_id + '/schedule/my/' + res.data.show_date);
      setShowDetails(res.data.show)
      setEntries(res.data.entries)
      setCurrentShow(res.data.show.show_id)
      setShowDaysList(res.data.show_days_list)
      setShowDate(res.data.show_date)
      setLoading(false)
      
    })
  }
  const getAllData = (show_date, show) => {
    getUserData();

    axios.all([
      axios.get(Sgl.nestApiUrl + '/schedule/my', {
        params: {
          date: show_date,
          show_id: show,
          customer_id: Sgl.company_id,
          team_id: Sgl.currentTeamId != 'personal'?Sgl.currentTeamId:0,
        }
      }),
    ]).then(axios.spread((res) => {
      Sgl.reportToGA('/sgl-wp-plugin/' + Sgl.company_urlpath + '/' + res.data.show.show_id + '/schedule/my/' + res.data.show_date);
      Sgl.reportToFB('/sgl-wp-plugin/' + Sgl.company_urlpath + '/' + res.data.show.show_id + '/schedule/my/' + res.data.show_date);
      setShowDetails(res.data.show)
      setEntries(res.data.entries)
      setCurrentShow(res.data.show.show_id)
      setShowDaysList(res.data.show_days_list)
      setShowDate(res.data.show_date)
      setLoading(false)
      document.title =
          "My Schedule for " +
          show_details.show_name +
          " (" +
          show_date +
          ")";
    }))

  }

  const onDateChange = (e) => {
    getScheduleData(e.target.value, props.currentShow);
  }

  const openTab = (tabName) => (e) => {
    setDisplay(tabName)
    var i, tablinks;

    tablinks = document.getElementsByClassName("tablinks");
    for (i = 0; i < tablinks.length; i++) {
      tablinks[i].className = tablinks[i].className.replace(" active", "");
    }
    e.currentTarget.className += " active";
  }

  const format_time = (timeString) => {
    var H = +timeString.substr(0, 2);
    var h = H % 12 || 12;
    var ampm = (H < 12 || H === 24) ? " AM" : " PM";
    timeString = h + timeString.substr(2, 3) + ampm;
    return timeString;
  }

  const format_phone = (num) => {
    num = num.replace(/[^0-9]/, '');
    var len = num.length;

    if (len == 7) {
      num = num.replace(/([0-9]{3})([0-9]{4})/, '$1-$2');
    } else if (len == 10) {
      num = num.replace(/([0-9]{3})([0-9]{3})([0-9]{4})/, '($1) $2-$3');
    } else if (len == 11) {
      num = num.replace(/([0-9]{1})([0-9]{3})([0-9]{3})([0-9]{4})/, '+$1($2) $3-$4');
    }

    return num;
  }

  const getDisplayEntries = () => {
    if (display == 'all') {
      return entries;
    } else if (display == 'morning') {
      return entries.filter(entry => entry.is_morning == true);
    } else if (display == 'afternoon') {
      return entries.filter(entry => entry.is_morning == false);
    }
    return entries;
  }

  const getUserData = () => {
    axios.get(Sgl.nestApiUrl + '/users/getUser')
      .then((response) => {
        if (response.data.user && response.data.user != null) {
          setUserData(response.data.user)
        } else {
        }
      }, (error) => {
      });
  }


  if (loading) {
    return null;
  }
  const Display = () => {
    var display_entries = getDisplayEntries();
    return display_entries
  }

  return (
    <div className="sgl-plugin section-to-print">
      <section className="search-area">
        <table>
          <tbody>
            <tr>
              <select className="selection-list" value={show_date} onChange={(e) => onDateChange(e)}>
                {
                  show_days_list.map((show, index) => {
                    return (
                      <option value={`${show.date}`}>{show.display_date}</option>
                    )
                  })
                }
              </select>
            </tr>
          </tbody>
        </table>
      </section>
      <div className='credit-text'> {process.env.REACT_APP_CREDIT_TEXT}{" "} <a onClick={() => window.open(`https://www.showgroundslive.com`, '_blank', 'noopener,noreferrer')}> {process.env.REACT_APP_CREDIT_COMPANY} </a> </div><br />
      <div className="section-tab tab">
        <button className="tablinks active" onClick={openTab('all')}>All</button>
        <button className="tablinks" onClick={openTab('morning')}>Morning</button>
        <button className="tablinks" onClick={openTab('afternoon')}>Afternoon</button>
      </div>
      {(Display().length > 0) ?

        <div className="div-responsive">
          <table className="table table-hover table-striped">
            <tbody>
              <tr className="sgl-primary-header">
                <th>Entry</th>
                <th>Horse</th>
                <th>Rider</th>
                <th>Class</th>
                <th className='center-align'>Ring</th>
                <th className='center-align'>Order</th>
                <th>&nbsp;</th>
              </tr>
              {Display().map((entry, index) => {
                return (

                  <tr className="sgl-anchor">
                    <td className='center-align'>

                      <Link to={`/entries/detail?eid=${entry.entry_id}&sid=${current_show}`}>{entry.number}</Link>
                    </td>
                    <td>
                      <Link to={`/entries/detail?eid=${entry.entry_id}&sid=${current_show}`}>{entry.horse}</Link>
                    </td>
                    <td>
                      <Link to={'/people/detail?pid=' + entry.entry_class.rider_id + '&sid=' + current_show}>{entry.entry_class.rider_name}</Link>
                    </td>
                    <td>
                      <Link to={'/classes/detail?cid=' + entry.class_data.class_id + '&sid=' + current_show}>{entry.class_data.class_number} {entry.class_data.class_name}</Link>
                      {((entry.class_data.sponsor) ? <span className='sponsor_text'> (Sponsored By: {entry.class_data.sponsor})</span> : "")}
                    </td>
                    <td className='center-align'>{entry.class_data.ring}</td>
                    <td className='center-align'>{entry.order_of_go}</td>
                    <td width="30px">{entry.has_conflict ? <img src={exclamation_image} className="bullet-icon" /> : ''}</td>
                  </tr>
                )
              })
              }
            </tbody>
          </table>
        </div>
        :
        <div><p>You have no entries for this day.</p></div>
      }
      <div>
        <table className="table contains-border">
          <thead className="entry-detail-header">
            <tr className="sgl-primary-header">
              <th colSpan="6">Contact Info</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th colSpan="1" className="details-table-head">Show Phone:</th>
              <td colSpan="2">{(show_details.phone) ? (format_phone(show_details.phone)) : 'N/A'}</td>
            </tr>
            <tr>
              <th colSpan="1" className="details-table-head">Show Fax:</th>
              <td colSpan="2">
                {(show_details.fax) ? (format_phone(show_details.fax)) : 'N/A'}
              </td>
            </tr>
            <tr>
              <th colSpan="1" className="details-table-head">Email Address:</th>
              <td colSpan="2">{(show_details.email_address) ? <a href={"mailto:" + show_details.email_address}>{show_details.email_address}</a> : ''}</td>
            </tr>
            <tr>
              <th colSpan="1" className="details-table-head">Secretary Name:</th>
              <td colSpan="2">{show_details.secretary_name}</td>
            </tr>
            <tr>
              <th colSpan="1" className="details-table-head">Manager Name:</th>
              <td colSpan="2">{show_details.manager_name}</td>
            </tr>
          </tbody>
        </table>

      </div>
      <div className="copyright-text">{process.env.REACT_APP_COPYRIGHT_TEXT}</div>
    </div>
  )
}

export default MySchedule;